import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  return <section className="py-8 md:py-20 bg-gray-900 text-gray-50" data-id="element-27">
      <div className="container mx-auto px-3 md:px-6" data-id="element-28">
        <div className="text-center mb-4 md:mb-16" data-id="element-29">
          <div className="inline-flex items-center gap-1.5 md:gap-2 px-3 md:px-4 py-1 rounded-full bg-teal-600 text-white text-[10px] md:text-sm font-bold mb-2 md:mb-6" data-id="element-30">
            <Gift className="w-3 h-3 md:w-4 md:h-4" data-id="element-31" />
            REGALOS INCLUIDOS
          </div>
          <h2 className="text-lg md:text-4xl font-bold mb-1 md:mb-4" data-id="element-32">
            Llevate estos bonus exclusivos gratis
          </h2>
          <p className="text-xs md:text-base text-gray-400 max-w-2xl mx-auto" data-id="element-33">
            Para asegurarnos de que tengas éxito ordenando tus finanzas.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 gap-2 md:gap-8 max-w-5xl mx-auto" data-id="element-34">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gray-800 rounded-xl md:rounded-2xl border border-gray-700 overflow-hidden" data-id="element-35">
            <div className="relative h-24 md:h-64 overflow-hidden" data-id="element-36">
              <img src="https://cdn.magicpatterns.com/uploads/3kiHBLEGXwKiuAsgNgfX2o/planner.png" alt="Planificador Financiero Imprimible" className="w-full h-full object-cover" data-id="element-37" />
            </div>
            <div className="p-2.5 md:p-8" data-id="element-38">
              <div className="hidden md:flex w-12 h-12 bg-gray-700 rounded-xl items-center justify-center mb-6" data-id="element-39">
                <span className="text-2xl font-bold text-teal-500" data-id="element-40">1</span>
              </div>
              <h3 className="text-xs md:text-xl font-bold mb-1 md:mb-3" data-id="element-41">
                Planificador Financiero Imprimible
              </h3>
              <p className="hidden md:block text-base text-gray-400" data-id="element-42">
                Ideal si te gusta escribir a mano. Usalo para planificar tu mes,
                organizar prioridades y establecer tus objetivos financieros
                antes de pasarlos a la plantilla.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-gray-800 rounded-xl md:rounded-2xl border border-gray-700 overflow-hidden" data-id="element-43">
            <div className="relative h-24 md:h-64 overflow-hidden" data-id="element-44">
              <img src="https://cdn.magicpatterns.com/uploads/qepgUjAQtKwuA1emrD4615/tutorial.png" alt="Video Tutorial Paso a Paso" className="w-full h-full object-cover" data-id="element-45" />
            </div>
            <div className="p-2.5 md:p-8" data-id="element-46">
              <div className="hidden md:flex w-12 h-12 bg-gray-700 rounded-xl items-center justify-center mb-6" data-id="element-47">
                <span className="text-2xl font-bold text-teal-500" data-id="element-48">2</span>
              </div>
              <h3 className="text-xs md:text-xl font-bold mb-1 md:mb-3" data-id="element-49">
                Video Tutorial Paso a Paso
              </h3>
              <p className="hidden md:block text-base text-gray-400" data-id="element-50">
                No necesitás saber usar Excel. Te explico en video y desde cero
                cómo usar cada parte de la plantilla para que le saques el
                máximo provecho.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}